import { B2B_SITE_ORIGIN } from "@danishagro/shared/src/constants/urlRoot.constants";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getPage: any = () => {
    const path = window.location.pathname + window.location.search;
    const serverPageContent = globalThis.pageContent;

    // On localhost, always use the API fetch.
    if (window.location.hostname === "localhost" && window.location.pathname !== "/cart") {
        return fetch(`${B2B_SITE_ORIGIN}/api${path}`).then((response) => response.json());
    }

    // Try to get url from current pageContent from variable formats
    const serverUrl = serverPageContent?.url || serverPageContent?.groupProduct?.url;

    if (serverPageContent && path === serverUrl) {
        const pageContent = { ...serverPageContent };
        globalThis.pageContent = undefined;
        return new Promise((resolve) => resolve(pageContent));
    }

    return fetch(`${B2B_SITE_ORIGIN}/api${path}`).then((response) => response.json());
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getPageByUrl: any = (url: string) => {
    return fetch(`${B2B_SITE_ORIGIN}/api${url}`).then((response) => response.json());
};
